export const MSG_INFO = "MSG_INFO"
export const MSG_SUCCESS = "MSG_SUCCESS"
export const MSG_WRRING = "MSG_WRRING"
export const MSG_ERROR = "MSG_ERROR"
 export const MSG_HIDE = "MSG_HIDE"